<template name="addVisitorDetail">
  <div class="add-visitor-detail">
    <div class="visitor-detail-wrapper" v-show="showVisitorDetail">
      <div class="visitor-detail-container">
        <div class="row" :class="{ 'primary-title-row': isPrimaryVisitor }">
          <div class="col-6 title" v-show="!isPrimaryVisitor">
            {{ isForKOInnerVisitor ? $t('Internal') : '' }}{{$t('visitorInfo')}}
          </div>
          <div class="col-6 auto-btn">
            <button type="button" class="btn btn-outline-danger" @click="loadHistory">{{$t('AutomaticallyInfo')}}</button>
          </div>
        </div>
          <div>
            <!-- Add inner KO visitor -->
            <div class="row name-select" v-if="isForKOInnerVisitor">
              <div class="col-4">
                {{$t('UserInfo')}}
              </div>
              <div class="col-8">
                <input :placeholder="$t('SelectInternalVisitor')"
                  :value="currentVisitor.userName ? `${currentVisitor.userName} ${currentVisitor.contact}` : ''"
                  class="select-ko" type="text" @click="checkIfCanAddKO">
                <label class="error-msg" v-show="!validContact">
                {{ $t('SelectInternalVisitor') }}
                </label>
              </div>
            </div>
            <!-- Add other visitor -->
            <div class="row name-select" v-if="!isPrimaryVisitor && !isForKOInnerVisitor">
              <div class="col-4">
                {{$t('name')}}
              </div>
              <div class="col-8">
                <input :placeholder="$t('InputName')" type="text" name="" v-model.trim="currentVisitor.userName">
              </div>
            </div>
            <label class="error-msg" v-show="isNameEmpty" v-if="!isForKOInnerVisitor">
              {{$t('PleaseName')}}
            </label>
            <div class="row phone-select" :class="{'form-error': !validContact}" v-if="!isPrimaryVisitor && !isForKOInnerVisitor">
              <div class="col-4">
                <label @click="showContactSelect" class="control-label">
                  {{pickedContact}}
                  <i class="iconfont icon-down"></i>
                </label>
                <transition name="fade">
                  <div class="contact-select" v-show="isContactSelectShown">
                    <div class="inner">
                      <div class="form-group">
                        <input type="radio" id="phoneNum" :value="$t('mobile')" v-model="currentVisitor.pickedContact">
                        <label for="phoneNum" @click="hideContactSelect">{{$t('mobile')}}</label>
                      </div>
                      <div class="form-group">
                        <input type="radio" id="mailAddress" :value="$t('email')" v-model="currentVisitor.pickedContact">
                        <label for="mailAddress" @click="hideContactSelect">{{$t('email')}}</label>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
              <div class="col-8">
               <!-- actual input for type contact -->
               <input type="text" name="contact"
                   :placeholder="$t('addVisitor') + pickedContact"
                   @blur="checkContact"
                   :disabled="isExternalSystem && isEditLoginVisitor"
                   v-model.trim="currentVisitor.contact">
               </div>
            </div>
            <label class="error-msg" v-show="!validContact" v-if="!isPrimaryVisitor && !isForKOInnerVisitor">
              {{ !(currentVisitor.contact) ? ($t('PleaseInput') + pickedContact) : ($t('inputCorrect') + pickedContact) }}
            </label>

            <!-- render material options -->
            <div class="row" :class="{ 'company-field': material.isCompany, 'other-visitor': (isKOSystem && !isPrimaryVisitor && !isForKOInnerVisitor) || (isExternalSystem && !currentVisitor.isPrimaryVisitor), 'radio-checkbox-row': material.materialType === 1 || material.materialType === 2 }"  v-for="(material, idx) in materials" :key="idx"
              v-show="(material.preQuestionId === -1 || (materials.find(x => x.id === material.preQuestionId).answer === material.preQuestionAnswer))">
                <div class="col-4 material-title" v-if="material.materialType === 1"> <!-- 单选 -->
                  {{ material.materialTitleTemplate }}{{ !material.isRequired ? $t('optional') : '' }}
                </div>
                <div class="col-8 radio-checkbox-col-8" v-if="material.materialType === 1"> <!-- 单选 -->
                  <!-- render options here -->
                  <span v-for="(option, idx) in JSON.parse(material.materialAnswerTemplate)" :key="idx">
                    <input type="radio" :name="material.materialTitleTemplate"
                      :value="option" :id="`${idx}-${material.id}-${isPrimaryVisitor ? 'primary' : 'other'}`" v-model.trim="material.answer">
                    <label :for="`${idx}-${material.id}-${isPrimaryVisitor ? 'primary' : 'other'}`" class="normal">{{ option }}</label>
                  </span>
                </div>
                <div class="col-4 material-title" v-if="material.materialType === 2"> <!-- 多选 -->
                  {{ material.materialTitleTemplate }}{{ !material.isRequired ? $t('optional') : '' }}
                </div>
                <div class="col-8 radio-checkbox-col-8" v-if="material.materialType === 2"> <!-- 多选 -->
                  <span v-for="(option, idx) in JSON.parse(material.materialAnswerTemplate)" :key="idx">
                    <input type="checkbox" class="type-2"  :name="material.materialTitleTemplate" v-model="material.answer"
                      :value="option" :id="`${idx}-${material.id}-${isPrimaryVisitor ? 'primary' : 'other'}`">
                    <label :for="`${idx}-${material.id}-${isPrimaryVisitor ? 'primary' : 'other'}`">{{ option }}</label>
                  </span>
                </div>
                <div class="row" v-if="material.materialType === 3"> <!-- 简答题 -->
                  <div class="col-4 material-title">{{ material.materialTitleTemplate }}{{ !material.isRequired ? $t('optional') : '' }}</div>
                  <div class="col-8">
                    <input :placeholder="material.id === 37 ? $t('tonnagePlaceholder') : material.materialTitleTemplate" type="text" name="" :id="material.id" v-model.trim="material.answer" @blur="loadCompanyHistory(material.isCompanyName, $event)">
                  </div>
                </div>
                <div class="col-12" v-if="material.materialType === 4"> <!-- 问答题 -->
                  {{ material.materialTitleTemplate }}{{ !material.isRequired ? $t('optional') : '' }}
                </div>
                <div class="col-12" v-if="material.materialType === 4"> <!-- 问答题 -->
                  <textarea :placeholder="material.materialTitleTemplate" name="" :id="material.id" cols="30" rows="2" v-model="material.answer">
                  </textarea>
                </div>
                <div class="col-4 material-title" v-if="material.materialType === 5"> <!-- 日期 -->
                  {{ material.materialTitleTemplate }}{{ !material.isRequired ?  $t('optional') : '' }}
                </div>
                <div class="col-8" v-if="material.materialType === 5"> <!-- 日期 -->
                  <dateTimePicker
                    v-model="material.answer"
                    :placeholder="material.materialTitleTemplate"
                  ></dateTimePicker>
                </div>
                <div class="col-12 annex-file" v-if="material.materialType === 6"> <!-- 附件 -->
                  <div v-show="material.answer">
                    <div v-for="(name, idx) in material.names" :key="idx" class="annex-name">
                      {{ name }}
                      <b @click="handleDeleteAnnex(idx, `${material.id}-${isPrimaryVisitor ? 'primary' : 'other'}`, material.id)">
                        <img src="../assets/images/delete-add.png" >
                      </b>
                    </div>
                  </div>
                  <input type="file" class="file-input" accept=".doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf" :id="`${material.id}-${isPrimaryVisitor ? 'primary' : 'other'}`" @change="handleAnnexChange(`${material.id}-${isPrimaryVisitor ? 'primary' : 'other'}`, material.id, $event)" multiple="multiple">
                  <img src="../assets/images/add_2.png" >
                  {{ material.materialTitleTemplate }}{{ !material.isRequired ? $t('optional') : '' }}
                </div>
                <div class="col-12 document-photo" v-show="material.optionCode != 2" v-if="material.materialType === 7 || material.materialType === 9"> <!-- 证件照 需要水印处理-->
                  {{ material.materialTitleTemplate }}{{ !material.isRequired ? $t('optional') : '' }}
                  <div v-show="material.answer && material.answer.length" class="preview-img" v-for="(answer, idx) in material.answer">
                    <img :src="answer">
                    <b class="delete-img" @click="handleDeleteImg(idx, `${material.id}-${isPrimaryVisitor ? 'primary' : 'other'}`, material.id)">
                      <img src="../assets/images/close-b@2x.png">
                    </b>
                  </div>
                  <input class="img-file" type="file" accept="image/x-png,image/gif,image/jpeg" :id="`${material.id}-${isPrimaryVisitor ? 'primary' : 'other'}`" @change="handleImgChange(`${material.id}-${isPrimaryVisitor ? 'primary' : 'other'}`, material.id, material.materialType, $event)"  multiple="multiple">
                  <div>
                    <img src="../assets/images/picture@2x.png" >
                    <p>{{$t('Uploadpicture')}}</p>
                  </div>
                </div>
                <div class="col-12 document-photo" v-if="material.optionCode === 2"> <!-- 面部近照-->
                  {{ material.materialTitleTemplate }}{{ !material.isRequired ? $t('optional') : '' }}
                  <div v-show="material.answer && material.answer.length" class="preview-img" v-for="(answer, idx) in material.answer">
                    <img :src="answer" width="100%" height="100%">
                    <b class="delete-img" @click="handleDeleteImg(idx, `${material.id}-${isPrimaryVisitor ? 'primary' : 'other'}`, material.id)">
                      <img src="../assets/images/close-b@2x.png">
                    </b>
                  </div>
                  <input class="img-file" type="file" accept="image/x-png,image/gif,image/jpeg" :id="`${material.id}-${isPrimaryVisitor ? 'primary' : 'other'}`" @change="handleFaceImgChange(`${material.id}-${isPrimaryVisitor ? 'primary' : 'other'}`, material.id, material.materialType, $event)"  multiple="multiple">
                  <div>
                    <img src="../assets/images/picture@2x.png" >
                    <p>{{$t('Uploadpicture')}}</p>
                  </div>
                </div>
                <div class="col-4 material-title" v-if="material.materialType === 8"> <!-- 判断 -->
                  {{ material.materialTitleTemplate }}{{ !material.isRequired ? $t('optional') : '' }}
                </div>
                <div class="col-8 radio-checkbox-col-8" v-if="material.materialType === 8">
                  <input type="checkbox" class="switch-input" :value="material.materialAnswerTemplate"
                    :name="material.materialTitleTemplate" :id="`${material.id}-${isPrimaryVisitor ? 'primary' : 'other'}`"
                    :checked="material.answer === JSON.parse(material.materialAnswerTemplate)[0]"
                    @change="handleTrueFalseChange">
                  <label class="switch" :for="`${material.id}-${isPrimaryVisitor ? 'primary' : 'other'}`"></label>
                </div>
                <label class="error-msg" v-show="material.isError">
                  {{$t('required')}}
                </label>
            </div>
          </div>
        </div>
        <div class="row operation-btn">
          <div class="col-6">
            <button type="button" class="btn" @click="emptyVisitorDetail">
              {{ isPrimaryVisitor ? $t('Clear') : $t('delete') }}
            </button>
          </div>
          <div class="col-6">
            <button type="button" class="btn" @click="saveVisitorDetail">{{$t('save')}}</button>
          </div>
        </div>
    </div>
    <div class="add-btn new-invite-title" @click="addVisitorDetail" v-if="!isPrimaryVisitor && isKOSystem" v-show="!showVisitorDetail && (isForKOInnerVisitor ? materials.length : true)">
      <i class="iconfont icon-add"></i>
      <span>
        {{ $t('Add') }}{{isForKOInnerVisitor ? $t('Internal') : ''}}{{$t('visitorInfo')}}
      </span>
    </div>
    <loading :active.sync="isLoading" :color="'#e42029'"></loading>
    <koList v-show="isAddKO" :isSingleSelect="true" :koListItem="$props.koListItem"  @koStatus="handleSelectKO"></koList>
    <alertModal
      modalType="simple"
      :isModalShown="isAlertModalShow"
      :modalTitle="$t('PleaseAddInternalVisitor')"
      @cancel="isAlertModalShow = false"
    >
    </alertModal>
  </div>
</template>

<script type="text/javascript">

import { checkNested, regExp, correctImgOrientation, scrollErrMsgToView } from '@/utils/utils';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import dateTimePicker from '@/components/dateTimePicker.vue';
import koList from '@/components/koList.vue';
import alertModal from '@/components/alertModal.vue';
import {
  uploadPictureByBase64,
  uploadPictureByBase64Ex,
  faceImageByBase,
  faceImageByBaseEx,
  uploadAnnex,
  uploadAnnexExternal,
} from '@/utils/api';

export default {
  name: 'addVisitorDetail',
  props: {
    isKOSystem: Boolean,
    isExternalSystem: Boolean,
    materials: Array,
    currentVisitor: Object,
    showVisitorDetail: Boolean,
    isPrimaryVisitor: Boolean,
    isEditLoginVisitor: Boolean,
    // for add ko inner visitor
    isForKOInnerVisitor: Boolean,
    koListItem: Array,
  },
  components: {
    Loading,
    dateTimePicker,
    koList,
    alertModal,
  },
  data() {
    return {
      validContact: true,
      isNameEmpty: false,
      pickedContact: this.$t('mobile'), // init state
      isContactSelectShown: false,
      isLoading: false,
      isDeleteModalShow: false,
      // some special logic for add ko user
      isAddKO: false,
      isAlertModalShow: false,
    };
  },
  created() {
    // console.log(this.$props.isKOSystem);
    // console.log(this.$props.isPrimaryVisitor);
  },
  updated() {
    // get latest state from parent
    if (!this.$props.isPrimaryVisitor) {
      this.pickedContact = this.$props.currentVisitor.pickedContact;
    }
  },
  methods: {
    hideContactSelect(e) {
      if (!this.$props.isPrimaryVisitor) {
        this.pickedContact = e.target.textContent;
        this.isContactSelectShown = false;
        this.validContact = true;
        this.$emit('hideContactSelect');
      }
    },
    checkContact() {
      if (!this.$props.isPrimaryVisitor) {
        if (this.pickedContact === this.$t('mobile')) {
          this.validContact = regExp.phone.test(this.$props.currentVisitor.contact);
        } else {
          this.validContact = regExp.email.test(this.$props.currentVisitor.contact);
        }
      }
    },
    showContactSelect() {
      if (!(this.$props.isEditLoginVisitor && this.$props.isExternalSystem)) {
        this.isContactSelectShown = true;
        this.$emit('showContactSelect');
      }
    },
    addVisitorDetail(event) {
      const { isForKOInnerVisitor } = this.$props;
      if (isForKOInnerVisitor) {
        this.validContact = true;
      }
      this.$emit('addVisitorDetail', event);
    },
    emptyVisitorDetail() {
      this.$emit('clearCurrent', this.$props.isPrimaryVisitor);
    },
    saveVisitorDetail() {
      // check name and phonenumber before emit save event
      this.isNameEmpty = !this.$props.isPrimaryVisitor && !this.$props.currentVisitor.userName;
      this.checkContact();
      if (this.isPrimaryVisitor || (!this.isNameEmpty && this.validContact)) {
        // trigger parent component DetailIndex  handleSaveCurrent event
        this.$emit('saveCurrent', { isKOSystem: this.$props.isKOSystem, isPrimaryVisitor: this.$props.isPrimaryVisitor });
      } else {
        !this.$props.isKOSystem && scrollErrMsgToView('.add-visitor-detail-container');
      }
    },
    // these 3 types are handled by own code, others use v-model
    handleImgChange(eleId, mId, mType, event) {
      this.isLoading = true;
      const self = this;
      const waterMark = mType === 7 ? 1 : 0;
      const uploadPicture = this.$props.isKOSystem ? uploadPictureByBase64 : uploadPictureByBase64Ex;
      const imgHandler = (dataUrl, imgIndex) => {
        uploadPicture({ isDocPhoto: waterMark, filePath: dataUrl }).then((res) => {
          // if all is uploaded
          if (imgIndex === event.target.files.length - 1) {
            document.getElementById(eleId).value = null;
            self.isLoading = false;
          }
          if (checkNested(res, 'data', 'content', 'model')) {
          // get img URL
            self.$emit('answer', {
              materialOptionId: mId,
              answer: res.data.content.model,
              type: 'document-photo',
              isPrimaryVisitor: self.$props.isPrimaryVisitor,
            });
          }
        });
      };
      for (let i = 0; i < event.target.files.length; i++) {
        (function (a) {
          // console.log(event.target.files[a]);
          correctImgOrientation(event.target.files[a], (base64Url) => { imgHandler(base64Url, a); });
        }(i));
      }
    },
    handleFaceImgChange(eleId, mId, mType, event) {
      this.isLoading = true;
      const self = this;
      const waterMark = mType === 7 ? 1 : 0;
      const uploadPicture = this.$props.isKOSystem ? faceImageByBase : faceImageByBaseEx;
      const imgHandler = (dataUrl, imgIndex) => {
        uploadPicture({ isDocPhoto: waterMark, filePath: dataUrl }).then((res) => {
          // if all is uploaded
          if (imgIndex === event.target.files.length - 1) {
            document.getElementById(eleId).value = null;
            self.isLoading = false;
          }
          if (checkNested(res, 'data', 'content', 'model')) {
          // get img URL
            self.$emit('answer', {
              materialOptionId: mId,
              answer: res.data.content.model,
              type: 'document-photo',
              isPrimaryVisitor: self.$props.isPrimaryVisitor,
            });
          }
        });
      };
      for (let i = 0; i < event.target.files.length; i++) {
        (function (a) {
          // console.log(event.target.files[a]);
          correctImgOrientation(event.target.files[a], (base64Url) => { imgHandler(base64Url, a); });
        }(i));
      }
    },
    handleDeleteImg(idx, id, materialId) {
      // empty input value in order to trigger change event next time
      document.getElementById(id).value = null;
      this.$emit('deleteImg', { idx, materialId, isPrimaryVisitor: this.$props.isPrimaryVisitor });
    },
    handleAnnexChange(eleId, mId, event) {
      this.isLoading = true;
      const self = this;
      const uploadAnnexMethod = this.$props.isKOSystem ? uploadAnnex : uploadAnnexExternal;
      for (let i = 0; i < event.target.files.length; i++) {
        (function (a) {
          const fd = new FormData();
          const { name } = event.target.files[a];
          fd.append('fileData', event.target.files[a]);
          uploadAnnexMethod(fd).then((res) => {
            if (a === event.target.files.length - 1) {
              document.getElementById(eleId).value = null;
              self.isLoading = false;
            }
            if (checkNested(res, 'data', 'content', 'model')) {
              // get annex url
              // console.log(res.data.content.model);
              self.$emit('answer',
                {
                  materialOptionId: mId,
                  answer: `${res.data.content.model},${name}`,
                  type: 'annex',
                  name,
                  isPrimaryVisitor: self.$props.isPrimaryVisitor,
                });
            }
          });
        }(i));
      }
    },
    handleDeleteAnnex(idx, id, materialId) {
      this.$emit('deleteAnnex', { idx, materialId, isPrimaryVisitor: this.$props.isPrimaryVisitor });
    },
    handleTrueFalseChange(event) {
      const id = parseInt(event.target.id, 10);
      const valArr = JSON.parse(event.target.value);
      const val = event.target.checked ? valArr[0] : valArr[1];
      this.$emit('answer', {
        materialOptionId: id,
        answer: val,
        type: 'trueFalse',
        isPrimaryVisitor: this.$props.isPrimaryVisitor,
      });
    },
    loadHistory() {
      this.$emit('loadHistory');
    },
    loadCompanyHistory(isCompanyName, event) {
      if (isCompanyName) {
        this.$emit('loadCompanyHistory', { companyName: event.target.value, isPrimaryVisitor: this.$props.isPrimaryVisitor });
      }
    },

    // some special logic for add ko inner visitor
    handleSelectKO(data) {
      this.isAddKO = false;
      this.$emit('addKOUser', data[0]);
    },
    checkIfCanAddKO(event) {
      const { koListItem } = this.$props;
      if (koListItem.length) {
        this.isAddKO = !event.target.value;
        event.currentTarget.blur();
      } else {
        event.currentTarget.blur();
        this.isAlertModalShow = true;
      }
    },
  },
};
</script>

<style scoped lang="scss">
  input[type=number] {  
    appearance:textfield;  
  }  
  input[type=number]::-webkit-inner-spin-button,  
  input[type=number]::-webkit-outer-spin-button {  
    appearance: none;  
    margin: 0;  
  }
  .add-visitor-detail {
    .add-btn {
      padding: 12px;
    }
    .visitor-detail-wrapper {
      border-bottom: 1px solid #f0f1f2;
        padding: 0 12px;
        .visitor-detail-container {
          width: 100%;
          margin: 0 auto;

          /* visitor detail title */
          & > div:first-child {
            padding: 20px 0;
            font-size: 14px;
            color: #4a4a4a;
            &.primary-title-row {
              justify-content: flex-end;
              .auto-btn {
                padding-right: 0;
              }
            }
            .title {
              font-weight: bold;
            }
            .auto-btn {
              text-align: right;
              button {
                border-color: #e42029;
                color: #e42029;
                font-size: 11px;
                border-radius: 14.5px;
                background: #fff;
              }
            }
          }
          /* visitor detail title end */

          /* visitor detail content */
          & > div:last-child {
            div.row {
              margin: 0;
              padding-top: 17px;
              border-bottom: 1px solid #ddd;
              &.row.radio-checkbox-row {
                flex-direction: column;
                display: block;
                .material-title {
                  max-width: 100%;
                }
                .radio-checkbox-col-8 {
                  flex-direction: column;
                  align-items: flex-start;
                  max-width: 100%;
                  span {
                    width: 100%;
                    label {
                      padding-left: 0;
                      text-align: left;
                      width: 100%;
                      word-break: break-all;
                      &:before {
                        left: auto;
                        right: 0;
                      }
                    }
                    margin-bottom: 5px;
                    display: block;
                    :last-child {
                      margin-bottom: 0;
                    }
                  }
                }
              }
              &.company-field.other-visitor {
                display: none !important;
              }
              label {
                margin: 0;
                display: block;
                border-right: 1px solid #f0f1f2;
                i {
                  font-size: 12px;
                  padding-left: 2.5vw;
                  display: inline-block;
                  -webkit-transform: scale(0.75, 0.75);
                  transform: scale(0.75, 0.75);
                }
              }
              &:first-child {
                padding-top: 0;
              }
              &:last-of-type {
                border: none;
              }
              div {
                font-size: 13px;
                color: #4a4a4a;
                padding:  0 0 16px;
                & .select-ko {
                  background: url('../assets/images/arrow-copy.png') no-repeat right;
                  background-size: 8px;
                  padding-right: 20px;
                  width: 100%;
                }
                &:last-child {
                  &, & input {
                    text-align: right;
                  }
                  & input {
                    width: 100%;
                  }
                }
                &.radio-checkbox-col-8 {
                  display: flex;
                  justify-content: flex-end;
                  span:last-of-type {
                    label {
                      margin-right: 0;
                    }
                  }
                  label {
                    position: relative;
                    border: none;
                    margin-right: 25px;
                    display: inline-block;
                    padding-left: 20px;
                    color: #4a4a4a;
                    &:before, &::after {
                       content: '';
                       position: absolute;
                       display: block;
                       transition: all ease .3s;
                    }
                    &:before {
                      border: 2px solid #dadada;
                      border-radius: 9px;
                      width: 18px;
                      height: 18px;
                      background: transparent;
                      top: 0;
                      left: 0;
                    }
                    &:after {
                      background: #e42029;
                      border-radius: 4px;
                      width: 8px;
                      height: 8px;
                      top: 5px;
                      // left: 5px;
                      right: 5px;
                      opacity: 0;
                    }
                  }
                  input {
                    display: none;
                    &:checked {
                      & + label {
                        &:before {
                          background: transparent;
                          border-color: #e42029;
                        }
                        &:after {
                          right: 5px;
                          opacity: 1;
                        }
                      }
                    }
                    &.type-2:checked {
                      & + label {
                        &:before {
                          background: url(../assets/images/xuanzhong-copy-6.png) no-repeat center;
                          background-size: contain;
                          border: none;
                        }
                        &:after {
                          opacity: 0;
                        }
                      }
                    }
                  }
                  label.switch {
                    position: relative;
                    width: 48px;
                    height: 26px;
                    margin-right: 0;
                    &:before {
                      background: #dadada;
                      border-radius: 13px;
                      width: 48px;
                      height: 26px;
                      top: 0;
                      right: 0;
                    }
                    &:after {
                      background: #fff;
                      border-radius: 11px;
                      width: 22px;
                      height: 22px;
                      display: block;
                      top: 2px;
                      right: 24px;
                      opacity: 1;
                      left: auto;
                    }
                  }
                  input.switch-input {
                    display: none;
                      &:checked {
                        & + label {
                          &:before {
                            background: #e42029;
                          }
                          &:after {
                            right: 2px !important;
                          }
                        }
                      }
                    }
                }
                &.col-12 {
                  text-align: left;
                  textarea {
                    width: 100%;
                    background-color: #f0f0f0;
                    font-size: 13px;
                    color: #4a4a4a;
                    border: 0;
                    padding: 5px 10px;
                  }
                  img {
                    width: 20px;
                    margin-right: 10px;
                    height: 20px;
                  }
                }
                &.document-photo {
                  text-align: center;
                  div {
                    &.preview-img {
                      border: none;
                      width: 80%;
                      max-width: 300px;
                      position: relative;
                      .delete-img {
                        width: 20px;
                        position: absolute;
                        top: 0;
                        right: 0;
                        img {
                          width: 20px;
                        }
                      }
                      img {
                        width: 100%;
                        height: 100%;
                      }
                    }
                    text-align: center;
                    width: 33%;
                    margin: auto;
                    border: 1px dashed #d0d0d0;
                    padding-bottom: 0;
                    padding: 10px;
                    margin-top: 10px;
                    border-radius: 4px;
                    img {
                      margin-right: 0;
                      width: 21px;
                      height: 21px;
                    }
                    p {
                      margin-bottom: 0;
                      font-size: 11px;
                      color: #8a8b8a;
                      margin-top: 5px;
                    }
                  }
                }
                &.annex-file {
                  input[type="file"] {
                    top: auto;
                    bottom: 0;
                    //height: 55px;
                    width: 100%;
                    max-width: 100%;
                    outline: none;
                    &.file-input {
                      height: 45px;
                    }
                  }
                  .annex-name {
                    display: flex;
                    justify-content: space-between;
                    padding-bottom: 10px;
                    padding-right: 20px;
                    word-break: break-all;
                    text-align: left;
                    b {
                      position: relative;
                      left: 20px;
                    }
                    &:last-child {
                      padding-bottom: 0;
                    }
                    img {
                      margin-right: 0;
                    }
                  }
                }
                span {
                  color: #e42029;
                }
                input {
                  color: #4a4a4a;
                  border: none;
                  outline: none;
                }
              }
              .row {
                width: 100%;
                div[class^="col"] {
                  &.material-title {
                    text-align: left;
                  }
                  padding-bottom: 0;
                }
              }
            }
          }
          /* visitor detail content end */
        }
      .operation-btn {
        padding: 20px 0;
        border-top: 1px solid #f0f1f2;
        margin: 0 auto;
        div:first-child {
          padding-left: 0;
          button {
            color: #929292;
          }
        }
        div:last-child {
          padding-right: 0;
          button {
            color: #e42029;
          }
        }
        button {
          width: 100%;
          height: 40px;
          font-size: 15px;
          text-align: center;
          border: 1px solid;
          border-radius: 5px;
          font-weight: bold;
          border-radius: 5px;
        }
      }
      .contact-select {
        position: fixed;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background: rgba(0,0,0,.4);
        z-index: 99;
        .inner {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          border-radius: 10px 10px 0 0;
          padding-bottom: 0 !important;
          overflow: hidden;
          background: #f2f2f2;
        }
        .form-group {
          padding: 0 !important;
          width: 90%;
          margin: 0 auto;
          & + .form-group {
            border-top: 1px solid #ddd;
          }
        }
        input {
          display: none;
          &:checked + label {
            color: #e42029;
          }
        }
        label {
          margin-bottom: 0;
          padding: 13px;
          font-size: 20px;
          text-align: center;
          display: block;
        }
      }
    }
    .error-msg {
      color: #e42029;
      font-size: 11px;
      text-align: right;
      width: 100%;
    }
    input[type=file] {
      opacity: 0;
      position: absolute;
      width: 100%;
      left: 0;
      top: 0;
      bottom: 0;
      z-index: 98;
      filter: alpha(opacity=0);
      font-size: 30px;
      margin-right: -100px;
      outline: none;
      &.img-file {
        top: auto;
        height: 80px;
      }
    }
  }
</style>
